import Vue from 'vue'

import commonsApi from '@/api/commons'

import LumbreApp from '@/views/LumbreApp'

class MetaBreadcrumb {
  constructor (name, to) {
    this.name = name
    this.to = to
  }
}

export const generateRoutes = async () => {
  try {
    const { data } = await commonsApi.axiosGetWrapper('/frontendroutes/myroutes')
    const myRoutes = data

    const requiredViews = require.context(
      '@/views', // Path donde obtener las vistas
      true, // Busco en subcarpetas
      /[\w-]+\.vue$/
    )

    let regExp = null
    if (process?.env?.VUE_APP_PROYECT_VIEWS_FOLDER) {
      regExp = new RegExp(`^(\\.\\/${process.env.VUE_APP_PROYECT_VIEWS_FOLDER}\\/){1}\\S+.vue$|^(\\.\\/Lm[a-zA-Z0-9]+\\.vue$)|^(\\.\\/lumbresign\\/[a-zA-Z0-9\\/]+\\.vue$)`, 'i')
    } else {
      regExp = new RegExp(`^(\\.\\/[a-zA-Z0-9\\/]*Lm[a-zA-Z0-9]+\\.vue)|^(\\.\\/lumbresign\\/[a-zA-Z0-9\\/]+\\.vue$)`, 'i')
    }
    /*
      Si tengo definida una carpeta del proyecto busca y solo importa los archivos con "./[carpeta]/[...]"
      Si no tengo definida una carpeta del proyecto busca y solo importa los archivos con "./Lm[...].vue"
      Tambien incluyo los archivos de la carpeta "lumbresign" siempre
    */

    /*
      Funcionamiento: por cada archivo de /views (inclusive subcarpetas), evaluo si existe una ruta
      Si existe una ruta, tomo el componente y lo inserto en Vue
    */
    requiredViews.keys().forEach((fileName) => {
      if (regExp && fileName.match(regExp)) {
        const componentConfig = requiredViews(fileName)
        const componentName = fileName
          .replace(/^\.\//, '')
          .replace(/\.\w+$/, '')
          .split('-')
          .map((kebab) => kebab.charAt(0).toUpperCase() + kebab.slice(1))
          .join('')
          /**
           * En componentName va a estar el nombre del componente, pero es importante
           * recordar que para aquellos que estén anidados en carpetas y subcarpetas
           * las mismas también son parte del nombre del componente:
           *
           * Para las subcarpetas - Carpeta-Subcarpeta-LmComponente
           *
           * Ej:
           *  El componente: ./qms/views/LmQmsBranchOffices.vue
           *  Tiene como componentName: Qms-Views-LmQmsBranchOffices y así es como
           *  debe referenciarse en frontendroutes.service para hablar de este
           *  componente o vista en particular
           *
           * Es IMPORTANTE ademas saber que los archivos en minusculas los arma en camelcase.
           *
           */
          .split('/')
          .map((kebab) => kebab.charAt(0).toUpperCase() + kebab.slice(1))
          .join('-')

        if (myRoutes.length) {
          const useComponent = myRoutes.some(route => {
            // Si el componente esta en una subcarpeta, se debe configurar
            // 'component: Carpeta-Carpeta-Componente'
            const vueComponent = route.children.map(child => child?.component)
            return vueComponent.some(component => component.toLowerCase() === componentName.toLowerCase())
          })
          // Solo inserto los componentes que el usuario requiere a la instancia de Vue
          if (useComponent) {
            Vue.component(componentName, componentConfig.default || componentConfig)
          }
        }
      }
    })

    const routes = []

    if (Array.isArray(myRoutes)) {
      myRoutes.forEach(newRoute => {
        newRoute['component'] = LumbreApp

        if (newRoute?.meta?.breadcrumb) {
          newRoute.meta.breadcrumb = new MetaBreadcrumb(newRoute.meta.breadcrumb)
        }

        if (Array.isArray(newRoute?.children)) {
          newRoute.children = newRoute.children.map(child => {
            child.component = Vue.options.components[child.component]
            return child
          })
        }
        routes.push(newRoute)
      })
    }
    return routes
  } catch (error) {
    throw new Error('No se pudieron obtener las rutas para Lumbre.')
  }
}
